import React from "react";
import { HeaderContainer } from "./style";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
const Header = () => {
  const [menuStatus, setMenuStatus] = React.useState(false);
  return (
    <HeaderContainer menuStatus={menuStatus}>
      <Container>
        <div className="content">
          <Link to="/">
            <img src="/logo.png" alt="logo" className="logo" />
          </Link>
          <FiMenu className="menu-icon" onClick={() => setMenuStatus(true)} />
          <div className="overlay" onClick={() => setMenuStatus(false)} />
          <div className="slogan">
            سـامانه فــــــروش
            آرینا درایو
          </div>
          <ul className="menu">
            <li>
              <Link to="/sell">خرید خودرو</Link>
            </li>
            <li>
              <Link to="/circulars">اطلاعیه فروش</Link>
            </li>
          </ul>
          <Link to="/profile" className="panel-link">
            پنل کاربری
          </Link>
        </div>
      </Container>
    </HeaderContainer>
  );
};
export default Header;
